/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SearchResultDTO,
} from '../models/index';
import {
    SearchResultDTOFromJSON,
    SearchResultDTOToJSON,
} from '../models/index';

export interface GetWorksByDoiRequest {
    doi: string;
}

export interface GetWorksByIsbnRequest {
    isbn: string;
}

/**
 * 
 */
export class SearchServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getWorksByDoi without sending the request
     */
    async getWorksByDoiRequestOpts(requestParameters: GetWorksByDoiRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['doi'] == null) {
            throw new runtime.RequiredError(
                'doi',
                'Required parameter "doi" was null or undefined when calling getWorksByDoi().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doi'] != null) {
            queryParameters['doi'] = requestParameters['doi'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/search/doi`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWorksByDoiRaw(requestParameters: GetWorksByDoiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SearchResultDTO>>> {
        const requestOptions = await this.getWorksByDoiRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchResultDTOFromJSON));
    }

    /**
     */
    async getWorksByDoi(requestParameters: GetWorksByDoiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SearchResultDTO>> {
        const response = await this.getWorksByDoiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWorksByIsbn without sending the request
     */
    async getWorksByIsbnRequestOpts(requestParameters: GetWorksByIsbnRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['isbn'] == null) {
            throw new runtime.RequiredError(
                'isbn',
                'Required parameter "isbn" was null or undefined when calling getWorksByIsbn().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isbn'] != null) {
            queryParameters['isbn'] = requestParameters['isbn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/search/isbn`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWorksByIsbnRaw(requestParameters: GetWorksByIsbnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SearchResultDTO>>> {
        const requestOptions = await this.getWorksByIsbnRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchResultDTOFromJSON));
    }

    /**
     */
    async getWorksByIsbn(requestParameters: GetWorksByIsbnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SearchResultDTO>> {
        const response = await this.getWorksByIsbnRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
